import type { EquipmentAccessorialType } from './constants.ts'
import { createEquipmentCategory, defaultAccessorials } from './internal.ts'

const boxTruckAccessorials: EquipmentAccessorialType[] = [
  ...defaultAccessorials,
  'liftgate',
  'straps',
]
export const boxTruckEquipment = createEquipmentCategory(
  {
    bucket: 'box-truck',
    mode: 'truckload',
    workflows: ['truckload', 'ltl'],
    accessorialTypes: boxTruckAccessorials,
  },
  [
    { key: 'box-truck-16', name: "Box truck 16'" },
    { key: 'box-truck-24', name: "Box truck 24'" },
    { key: 'box-truck-26', name: "Box truck 26'" },
  ],
)
